module.exports = __webpack_public_path__ + "img/decentralization-key-metrics.2dbff870.png";